import React from 'react';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import colors from 'src/utils/colors';
import { SlButton } from 'src/components/BeaconV2Components/Header/SLDropdownMenu/SlButton';
import { AppFilterButton } from 'src/components/BeaconV2Components/common/AppFilterButton/AppFilterButton';
import ProductTable from './components/ProductTable';
import { getQueryParamValue } from 'src/utils/app';
import { useExportContent } from 'src/components/BeaconV2Components/ExperimentalLayout/ContentGeneration/hooks/useContentGenerate';
import { useContentGenerationStore } from './components/ProductTable/store';
import { useProductTable } from './components/ProductTable/useProductTable';
import { useSnackbar } from 'src/utils/Hooks';
import { GenerationStatusEnum } from './types';

const Profile = () => {
  const { exportContent, isPending: isExporting } = useExportContent();
  const { selectedItems } = useContentGenerationStore();
  const { allData } = useProductTable({});
  const { showSnackbar } = useSnackbar();

  const handleExport = () => {
    const retailerId = getQueryParamValue('rid', '');

    if (!retailerId) {
      showSnackbar({
        message: 'Missing retailer ID',
        type: 'error'
      });
      return;
    }

    // Get selected items that have been reviewed and have content generation IDs
    const reviewedItems = allData.filter(
      (item) =>
        selectedItems.has(item.retailerSku) &&
        item.status === GenerationStatusEnum.enum.REVIEWED &&
        item.skuContentGenerationId
    );

    if (reviewedItems.length === 0) {
      showSnackbar({
        message: 'No reviewed content items selected for export',
        type: 'error'
      });
      return;
    }

    const contentGenIds = reviewedItems.map((item) => item.skuContentGenerationId);

    exportContent({
      retailerId: Number(retailerId),
      skuContentGenerationIds: contentGenIds
    });
  };

  return (
    <>
      <Flex justifyContent="space-between">
        <Flex flexDirection="column">
          <Text variant="h4">Generation</Text>
          <Text
            variant="body1"
            sx={{
              marginTop: '8px',
              marginBottom: '16px'
            }}
          >
            Use this page to select the products you want to generate content for, assign content profiles to each SKU,
            and export newly generated content.
          </Text>
        </Flex>
        <Flex gap={16}>
          <AppFilterButton />
          <SlButton
            variant="normal"
            onClick={handleExport}
            disabled={isExporting}
          >
            {isExporting ? 'Exporting...' : 'Export'}
          </SlButton>
        </Flex>
      </Flex>
      <ProductTable />
    </>
  );
};

export default Profile;
